import React from 'react'
import { Skeleton as AntSkeleton } from 'antd'
import { SkeletonProps as AntSkeletonProps } from 'antd/lib/skeleton'

type Props = AntSkeletonProps

export const Skeleton: React.FC<Props> = ({
  className,
  avatar,
  children,
  active,
  loading,
  title,
  paragraph
}) => {
  return (
    <AntSkeleton
      className={className}
      avatar={avatar}
      paragraph={paragraph}
      title={title}
      loading={loading}
      active={active}
    >
      {children}
    </AntSkeleton>
  )
}
